import sum from "~/kernel/numbers/sum";
import type { Service } from "../models/Service";

export const ROW_COUNT_LIMIT = 10;

type TGroup = {
  services: Pick<Service, "id">[];
};

export default function shouldOpenPerDefault(groups: TGroup[]) {
  const rowCount = groups.length + sum(groups, (g) => g.services.length);
  return rowCount <= ROW_COUNT_LIMIT;
}
